export var translateData = [{
    "filters": "Filter",
    "legend": "Legend",
    "route": "Routes",
    "resetView": "Reset view",
    "stageYouth": "Early years [1485–1518]",
    "stageSchools": "Schools (1485–1500, 1507?)",
    "stagePilgrimage": "Pilgrimage to the Holy Land (1506)",
    "stageCongress": "First steps in diplomacy (1515-1517)",
    "stageDietPoland": "Diets of Kingdom of Poland",
    "stageDietPrussia": "Diets of Royal Prussia",
    "stageOther": "Other",
    "stageDiplomat": "Diplomat [1518– 1532]",
    "stage1mission": "1st diplomatic mission (1518-1519)",
    "stage2mission": "2nd diplomatic mission (1522-1523)",
    "stage3mission": "3rd diplomatic mission (1524-1532)",
    "stageBishop": "Bishop [1532– 1548]",
    "stage4mission": "4th diplomatic mission (1538)",
    "entriesLegendTitle": "Data",
    "entriesLegendData": "Itinerary Entries",
    "chronologicalLegendTitle": "Travel direction",
    "chronologicalLegendData": "Route",
    "travelsLegendTitle": "Travels",
    "selectCountries": "Select countries",
    "countries": "countries",
    "routeTooltip": "Show travel direction and filter by year",
    "filterEntries": "Entries: ",
    "filterSharpDates": "Dates: ",
    "filterCountRange": "Count entries: ",
    "allEntries": "all entries",
    "allDates": "all dates",
    "allRanges": "all ranges",
    "travelsLabel": "Travels",
    "datepickerSeparator": " to ",
    "datepickerApply": "Apply",
    "datepickerReset": "Reset",
    "datepickerFrom": "From",
    "datepickerTo": "To",
    "datepickerJanuary": "January",
    "datepickerFebruary": "February",
    "datepickerMarch": "March",
    "datepickerApril": "April",
    "datepickerMay": "May",
    "datepickerJune": "June",
    "datepickerJuly": "July",
    "datepickerAugust": "August",
    "datepickerSeptember": "September",
    "datepickerOctober": "October",
    "datepickerNovember": "November",
    "datepickerDecember": "December",
    "searchPlaceholder": "Search in places",
    "tooltip-dock": "dock",
    "tooltip-undock": "undock"
},
{
    "filters": "Filtry",
    "legend": "Legenda",
    "route": "Trasy",
    "resetView": "Resetuj widok",
    "stageYouth": "Młodość [1485–1518]",
    "stageSchools": "Szkoły (1485–1500, 1507?)",
    "stagePilgrimage": "Pielgrzymka do Ziemi Świętej (1506)",
    "stageCongress": "Pierwsze szlify w dyplomacji (1515-1517)",
    "stageDietPoland": "Sejmy Królestwa Polskiego",
    "stageDietPrussia": "Sejmy Prus Królewskich",
    "stageOther": "Inne",
    "stageDiplomat": "Dyplomata [1518– 1532]",
    "stage1mission": "I misja dyplomatyczna (1518-1519)",
    "stage2mission": "II misja dyplomatyczna (1522-1523)",
    "stage3mission": "III misja dyplomatyczna (1524-1532)",
    "stageBishop": "Biskup [1532– 1548]",
    "stage4mission": "IV misja dyplomatyczna (1538)",
    "entriesLegendTitle": "Dane",
    "entriesLegendData": "Wpisy",
    "chronologicalLegendTitle": "Kierunek podróży",
    "chronologicalLegendData": "Trasy",
    "travelsLegendTitle": "Podróże",
    "selectCountries": "Wybierz kraje",
    "countries": "kraje",
    "routeTooltip": "Pokaż kierunek podróży i filtruj według roku",
    "filterEntries": "Wpisy: ",
    "filterSharpDates": "Daty: ",
    "filterCountRange": "Liczba wpisów: ",
    "allEntries": "wszystkie",
    "allDates": "wszystkie",
    "allRanges": "wszystkie",
    "travelsLabel": "Podróże",
    "datepickerSeparator": " do ",
    "datepickerApply": "Zatwierdź",
    "datepickerReset": "Reset",
    "datepickerFrom": "Od",
    "datepickerTo": "Do",
    "datepickerJanuary": "Styczeń",
    "datepickerFebruary": "Luty",
    "datepickerMarch": "Marzec",
    "datepickerApril": "Kwiecień",
    "datepickerMay": "Maj",
    "datepickerJune": "Czerwiec",
    "datepickerJuly": "Lipiec",
    "datepickerAugust": "Sierpień",
    "datepickerSeptember": "Wrzesień",
    "datepickerOctober": "Październik",
    "datepickerNovember": "Listopad",
    "datepickerDecember": "Grudzień",
    "searchPlaceholder": "Wyszukaj miejsce",
    "tooltip-dock": "przypnij po prawej stronie",
    "tooltip-undock": "cofnij przypięcie"
}];
